import * as React from 'react';
import {
  Toolbar,
  Typography,
  ListItem,
  ListItemText,
  ListItemAvatar,
  Avatar,
  IconButton
} from "@mui/material";
import {AuthUserContext} from "../../../providers/auth-provider";
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import DownloadFileHelper from "../../../utils/download-file-helper";
export default function MessagesTopbar({callback}) {
  const {roomData} = React.useContext(AuthUserContext);

  return(

      <Toolbar sx={{backgroundColor:'#fff', mt: 1,borderBottom: '1px solid #ecebeb', paddingLeft: '5px!important', paddingRight: '5px!important', paddingBottom: '10px'}} >

        <ListItem alignItems="center">
          <ListItemAvatar >
            <Avatar alt={roomData?.title} src={roomData?.image} sx={{height: 50, width:50, mr:2}}
                    imgProps={{sx: {
                        p: roomData?.type && roomData?.type === 'support' ? 1 : 0
                      }}}
            />
          </ListItemAvatar>
          <ListItemText  primary={roomData?.title}
                         secondary={roomData?.subTitle}/>
          <IconButton  onClick={callback}>
            <MoreHorizIcon/>
          </IconButton>
        </ListItem>

      </Toolbar>

  )

}
